import { render } from "./manage-quote.vue?vue&type=template&id=99bc1c56"
import script from "./manage-quote.vue?vue&type=script&lang=js"
export * from "./manage-quote.vue?vue&type=script&lang=js"

import "./manage-quote.vue?vue&type=style&index=0&id=99bc1c56&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__